// utils
import Vue from 'vue'
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
import { getUrlParam } from './common/js/utils';

function i18nFactory (lang = 'CN') {
    const langList = [ 'CN', 'EN', 'TW']
    lang = lang.toUpperCase()
    if (!langList.includes(lang)) lang = 'CN'
    const i18n = new VueI18n({
        locale: lang,
        messages: {
            CN: require('./i18n/cn'),
            EN: require('./i18n/en'),
            TW: require('./i18n/tw')
        }
    })
    return i18n
}

const i18n = i18nFactory(getUrlParam('lang'))

export default i18n;